// frontend/src/components/Navbar.jsx

import React from 'react';
import companyLogo from '../assets/aqmlogo250x50.png';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

export default function Navbar() {
  return (
    <nav className="flex items-center justify-between px-8 py-4 bg-white shadow">
      {/* Logo section */}
      <div className="flex items-center">
        {/* 2) Wrap the logo with <Link to="/"> */}
        <Link to="/">
          <img
            src={companyLogo}
            alt="AquaMind AI"
            className="h-12 w-auto mr-2"
          />
        </Link>
      </div>
      <ul className="flex space-x-4">
        <li> <HashLink smooth to="/#services"> Services </HashLink> </li>
        <li> <HashLink smooth to="/#about"> About </HashLink> </li>
        <li>
        <HashLink
          smooth
          to="/#contact"
           className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
        >
        Contact Us
        </HashLink>
        </li>
      </ul>
    </nav>
  );
}

